import { PickerTOActions } from "./Action";

const initialState = {
  SaveQuantityDetailsSuccess: null,
  SaveQuantityDetailsFailure: null,
  MedicineBoxLogSuccess: null,
  MedicineBoxLogFailure: null,
  reasonsListSuccess: null,
  reasonsListError: null,
  reasonsListCheckerSuccess: null,
  reasonsListCheckerError: null,
  markPickerIssueSuccess: null,
  markPickerIssueFailure: null,
};

export const pickerTOReducer = (state = initialState, action) => {
  switch (action.type) {
    case PickerTOActions.SAVE_QUANTITY_BOX_SUCCESS:
      return {
        ...state,
        SaveQuantityDetailsSuccess: action.payload,
        SaveQuantityDetailsFailure: null,
      };
    case PickerTOActions.SAVE_QUANTITY_BOX_FAILURE:
      return {
        ...state,
        SaveQuantityDetailsSuccess: null,
        SaveQuantityDetailsFailure: action.payload,
      };

    case PickerTOActions.GET_MEDICINES_IN_BOX_SUCCESS:
      return {
        ...state,
        MedicineBoxLogSuccess: action.payload,
        MedicineBoxLogFailure: null,
      };
    case PickerTOActions.GET_MEDICINES_IN_BOX_FAILURE:
      return {
        ...state,
        MedicineBoxLogSuccess: null,
        MedicineBoxLogFailure: action.payload,
      };

    case PickerTOActions.GET_REASONS_LIST_SUCCESS:
      return {
        ...state,
        reasonsListSuccess: action.payload,
        reasonsListError: null,
      };
    case PickerTOActions.GET_REASONS_LIST_FAILURE:
      return {
        ...state,
        reasonsListSuccess: null,
        reasonsListError: action.payload,
      };

    case PickerTOActions.GET_CHECKER_REASONS_LIST_SUCCESS:
      return {
        ...state,
        reasonsListCheckerSuccess: action.payload,
        reasonsListCheckerError: null,
      };
    case PickerTOActions.GET_CHECKER_REASONS_LIST_FAILURE:
      return {
        ...state,
        reasonsListCheckerSuccess: null,
        reasonsListCheckerError: action.payload,
      };

    case PickerTOActions.MARK_PICKER_ISSUE_SUCCESS:
      return {
        ...state,
        markPickerIssueSuccess: action.payload,
        markPickerIssueFailure: null,
      };
    case PickerTOActions.MARK_PICKER_ISSUE_FAILURE:
      return {
        ...state,
        markPickerIssueSuccess: null,
        markPickerIssueFailure: action.payload,
      };

    default:
      return state;
  }
};
